var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcmsWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6504,
    r: 20,
    fill: "url(#paint0_linear_4503_38486)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7606 19.1858H23.2263V10.9505C23.2263 9.02893 22.1854 8.64004 20.9158 10.0812L20.0008 11.1221L12.2573 19.9293C11.1936 21.1302 11.6397 22.1139 13.241 22.1139H16.7753V30.3492C16.7753 32.2708 17.8162 32.6596 19.0858 31.2185L20.0008 30.1776L27.7443 21.3704C28.808 20.1695 28.3619 19.1858 26.7606 19.1858Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4503_38486",
    x1: 0,
    y1: 0.650391,
    x2: 40.8986,
    y2: 1.60999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C86F3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcmsWorkflow);
export default __webpack_public_path__ + "static/media/acms-workflow.e93d5543348f483664ee1d4cb2727007.svg";
export { ForwardRef as ReactComponent };